export const LOGO =
  "https://customer-assets.emergentagent.com/job_kitchen-pro-18/artifacts/i80za4ah_Manage%20Kitchen%20Logo.png";
export const BRAND_NAME = "manage.kitchen";
